<template>
  <div ref="container">
    <select id="yearDropDownList" style="width: 82px"></select>
    <select id="monthDropDownList" style="width: 82px"></select>
    <select id="evaluationDateDropDownList" style="width: 114px"></select>
    <slot v-bind:toolbar="toolbar"> </slot>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
const $ = kendo.jQuery

export default {
  name: 'RateToolbar',
  props: {
    rateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toolbar,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  methods: {
    onExport() {
      this.$emit('export', toolbar.getSelectedValues())
    },
  },
  async mounted() {
    await toolbar.createToolbar(this)
    this.$emit('change', toolbar.getSelectedValues())
  },
  beforeDestroy() {
    kendo.destroy(this.$refs.container)
  },
}

const toolbar = (() => {
  'use strict'
  let yearDropDown, monthDropDown, evaluationDateDropDown

  let vm

  function createYearDropDown() {
    return new Promise(function(resolve) {
      yearDropDown = $('#yearDropDownList')
        .kendoDropDownList({
          dataTextField: 'name',
          dataValueField: 'value',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/rate/getEvaluationDateYears',
                cache: false,
                data: function() {
                  return {
                    rateType: vm.rateType,
                  }
                },
                type: 'GET',
                dataType: 'json',
              },
            },
          },
          dataBound: function() {
            this.select(0)
            resolve(yearDropDown)
          },
          change: function() {
            monthDropDown.dataSource.read().then(function() {
              monthDropDown.trigger('change')
              //vm.$emit('change', getSelectedValues())
            })
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createMonthDropDown() {
    return new Promise(function(resolve) {
      monthDropDown = $('#monthDropDownList')
        .kendoDropDownList({
          dataTextField: 'name',
          dataValueField: 'value',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/rate/getEvaluationDateMonths',
                type: 'GET',
                dataType: 'json',
                cache: false,
                data: function() {
                  return {
                    year: yearDropDown.value(),
                    rateType: vm.rateType,
                  }
                },
              },
            },
          },
          dataBound: function() {
            this.select(0)
            resolve(monthDropDown)
          },
          change: function() {
            evaluationDateDropDown.dataSource.read().then(function() {
              evaluationDateDropDown.trigger('change')
            })
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createEvaluationDateDropDown() {
    return new Promise(function(resolve) {
      evaluationDateDropDown = $('#evaluationDateDropDownList')
        .kendoDropDownList({
          dataTextField: 'evaluationDateText',
          dataValueField: 'evaluationDateOa',
          dataSource: {
            transport: {
              read: {
                url: '/api/heroux/rate/getEvaluationDates',
                cache: false,
                type: 'GET',
                dataType: 'json',
                data: function() {
                  return {
                    year: yearDropDown.value(),
                    month: monthDropDown.value(),
                    rateType: vm.rateType,
                  }
                },
              },
            },
          },
          dataBound: function() {
            this.select(0)
            resolve(evaluationDateDropDown)
          },
          change: function() {
            //loadEvaluationDateData();
            vm.$emit('change', getSelectedValues())
          },
        })
        .data('kendoDropDownList')
    })
  }

  function createRateToolbar() {
    return new Promise(function(toolbarResolve) {
      createYearDropDown().then(function() {
        createMonthDropDown().then(function() {
          createEvaluationDateDropDown().then(function() {
            //loadEvaluationDateData();
            toolbarResolve()
          })
        })
      })
    })
  }

  function getSelectedValues() {
    return {
      clientId: vm.clientId,
      rateTypeId: vm.rateType,
      year: yearDropDown.value(),
      month: monthDropDown.value(),
      evaluationDateOa: evaluationDateDropDown.value(),
    }
  }

  return {
    createToolbar($vm) {
      vm = $vm
      return createRateToolbar()
    },
    getSelectedValues: getSelectedValues,
  }
})()
</script>
